module.exports = __webpack_public_path__ + "assets/img/logo_100x100.ee2f9c3f.png";